import { ImpersonationBanner } from "@/features/admin/ImpersonationBanner";
import { AppProviders } from "./providers";
import { AppRoutes } from "./router";

export function App() {
  return (
    <AppProviders>
      <ImpersonationBanner />
      <AppRoutes />
    </AppProviders>
  );
}
